<template>
  <div class="calendar-categories" :class="[{'is-open': isOpen}, `scrollY-${scrollY}`]">
    <div class="min" @click="onClickMini">
      <div class="arrow arrow-left" />
      <div class="label">
        {{ getMonthText() }}
        <br>
        {{ getYearText() }}
      </div>
    </div>
    <div class="normal">
      <span class="icon icon-cross" @click="onClickClose" />
      <div class="layout-container">
        <Calendar :selected.sync="selected" @change="onChangeSelected" />
        <Categories :selected.sync="selected" :event-categories="eventCategories" @change="onChangeSelected" />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import Calendar from '@/components/Calendar'
import Categories from '@/components/Categories'

export default {
  components: {
    Calendar,
    Categories
  },
  props: [
    'selected',
    'eventCategories'
  ],
  data () {
    return {
      scrollY: null,
      isOpen: false,
      scrollCanvas: null
    }
  },
  mounted () {
    this.scrollCanvas = this.$parent.$refs.scrollCanvas
    this.scrollY = this.scrollCanvas.scrollTop
    this.scrollCanvas.addEventListener('scroll', this.onScroll)
  },
  destroyed () {
    this.scrollCanvas.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onClickMini () {
      this.isOpen = true
    },
    onClickClose () {
      this.isOpen = false
    },
    getMonthText () {
      const month = _.toUpper(moment(this.selected.date).format('MMM'))
      return this.$filters.translate(`T_${month}`)
    },
    getYearText () {
      return moment(this.selected.date).format('YYYY')
    },
    onChangeSelected (selected) {
      this.$emit('change', selected)
    },
    onScroll (event) {
      if (this.scrollCanvas.scrollTop > 541) {
        this.scrollY = 541
      } else if (this.scrollCanvas.scrollTop > 305) {
        this.scrollY = 305
      } else {
        this.scrollY = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/_variables.scss';

.calendar-categories {
  z-index: 3;
  position: absolute;
  margin-top: 45px;
  top: 541px;
  right: 0px;
  box-shadow: 0px 0px 5px grey;
  background-color: $color-hkbu-blue;
  padding-top: 20px;

  &.scrollY-541{
    position: fixed;
    top: 0px;
  }
  .min {
    cursor: pointer;
    margin-top: -20px;
    width: 94px;
    height: 87px;
    color: white;
    font-family: Poppins-bold;
    font-size: 20px;
    line-height: 30px;
    text-align: right;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
      background-color: $color-light-blue;
    }
  }

  .normal {
    display: none
  }

  &.is-open {
    .min {
      display: none
    }
    .normal {
      display: block
    }
  }

  .arrow-left {
    border: solid white;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 5px;
    margin-left: 15px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
  }

  .label {
    padding-right: 10px;
  }

  .icon {
    cursor: pointer;
    position: absolute;
    top: 0px;
    right: 0px;
    display: inline-block;
    min-width: 18px;
    width: 60px;
    height: 60px;
    background-repeat: no-repeat;
    background-position: center center;
    cursor: pointer;
    &.icon-cross {
      background-image: url('@/assets/icon-cross-white.png');
    }
  }

  .layout-container {
    display: flex;
    flex-direction: column;
  }
}

@media screen and (min-width: 1800px)
{
  .calendar-categories {
    box-shadow: none;
    padding-top: 0px;
    .min {
      display: none;
    }
    .normal {
      display: block;
      .icon-cross {
        display: none;
      }
    }
  }
}

@media screen and (max-width: 1280px)
{
  .calendar-categories {
    top: 305px;

    &.scrollY-305{
      position: fixed;
      top: 0px;
    }
  }
}

@media screen and (max-width: 768px)
{
  .calendar-categories {
    display: none;
  }
}

@media screen and (max-height: 860px) {
  .calendar-categories {
    .layout-container {
      display: flex;
      flex-direction: row;
    }
    .categories {
      margin-top: -20px;
    }
    .icon {
      &.icon-cross {
        background-image: url('@/assets/icon-cross.png');
      }
    }
  }
}

@media screen and (min-width: 1800px) and (max-height: 860px)
{
  .calendar-categories {
    .categories {
      margin-top: 0px;
    }
  }
}

</style>
